// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStkbptv2 } from "../../../icons/full/build/icon-stkbptv2.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StkbptvTwoIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStkbptv2.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StkbptvTwoIcon.displayName = 'StkbptvTwoIcon';
}

export default StkbptvTwoIcon;